module.exports = __webpack_public_path__ + "static/media/$pac.c830fed4.svg";